import * as React from "react";
import { cn } from "@/lib/utils";

const SIZES = {
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-8 w-8 border-[3px]",
} as const;

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: keyof typeof SIZES;
  /** Accessible label announced to screen readers. */
  label?: string;
}

/** The one loading spinner: a brand-colored ring with a transparent gap. */
export function Spinner({ size = "md", label = "Loading", className, ...props }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={label}
      className={cn(
        "inline-block animate-spin rounded-full border-brand-600 border-t-transparent",
        SIZES[size],
        className,
      )}
      {...props}
    />
  );
}

/** Spinner centered in a padded block — the common "section is loading" case. */
export function SpinnerBlock({ className, ...props }: SpinnerProps) {
  return (
    <div className={cn("flex items-center justify-center py-12", className)}>
      <Spinner {...props} />
    </div>
  );
}
